import React from 'react'
import { Plus } from '@phosphor-icons/react'

export function CreateVersionAction({
  hasDraft,
  isCreatingDraft,
  onCreateDraft,
}: {
  hasDraft: boolean
  isCreatingDraft: boolean
  onCreateDraft: () => void
}) {
  return (
    <div className="gw-version-bar__create-wrap">
      <button
        type="button"
        onClick={() => !hasDraft && !isCreatingDraft && onCreateDraft()}
        disabled={hasDraft || isCreatingDraft}
        className={`gw-version-bar__create-btn ${
          hasDraft || isCreatingDraft ? 'gw-version-bar__create-btn--disabled' : ''
        }`}
      >
        <Plus size={16} weight="regular" aria-hidden />
        {isCreatingDraft ? 'Creating…' : 'Create New Version'}
      </button>
      {hasDraft ? (
        <div className="gw-version-bar__tooltip">
          A draft version already exists. Edit or delete it first.
        </div>
      ) : null}
    </div>
  )
}
